// Instantiaing Smooth Scroll
var scroll = new SmoothScroll('a[href*="#"]');

const windowHash = window.location.hash;
const scrollOffset = 0; //Modify this header to clear the height of sticky elements

const stickyISI = (function() {
	// get position of the isi bar
	var isiBar = document.querySelector('.g-Isi_Snippet');
	var isiContent = document.querySelector('.g-Isi');
	var isiToggle = document.querySelector('.g-Isi_Icon');
	
	var setISI = () => {
		var isiPosition = isiContent.offsetTop;
		var windowHeight = window.innerHeight;
		var scrollTop = window.scrollY || document.body.scrollTop || window.pageYOffset || 0;

		// get scroll top position
		var windowScrollPosition = scrollTop + windowHeight - 200;

		if (isiPosition >= windowScrollPosition) { 
			isiBar.classList.add('show');
		} else {
			isiBar.classList.remove('show');
		}
	}

	var scrollToISI = () => {
		if (isiBar) { 
			isiBar.addEventListener('click', function () {
				console.log('isis bar click');
				scroll.animateScroll(isiContent); 
			})
		}
	}

	window.addEventListener('resize', (e) => {
		if (window.location.href.indexOf('ed=1') === -1 ) {
			setISI();
		}
		
	});

	window.addEventListener('scroll', function () {
		if (window.location.href.indexOf('ed=1') === -1) {
			setISI();
		}
	})

	window.addEventListener('load', (e) => {
		// Initialize
		if (window.location.href.indexOf('ed=1') > -1 && window.location.href.indexOf('isi=1') === -1) {
			//Don't load ISI bar if ED=1
		} else if (window.location.href.indexOf('ed=1') > -1 && window.location.href.indexOf('isi=1') > -1) {
			//Load the ISI bar in a preconfigured state
			let isiscreenshotstyles = { 
				position: "absolute", 
				left: "0", 
				top: "768px", 
				height: (window.innerWidth >= 768) ? "128px" : "128px", 
				display: "block", 
				opacity: "1" 
			};
			Object.assign(isiBar.style, isiscreenshotstyles);
		} else {
			setISI(); 
			scrollToISI();
		}
	});
});
stickyISI();

const getElementByPageHash = (hash) => {
	return (hash !== '' && hash.indexOf('#') === 0)
		? document.getElementById(hash.substring(1))
		: null;
};

const scrollToElement = (el, offset, scrollbehavior) => {
	if (!el) { return; }

	let pos = getElementOffset(el);
	let scrolloptions = {
		top: pos.top - offset,
		left: 0,
		behavior: (typeof scrollbehavior === 'undefined') ? 'auto' : 'smooth'
	}

	setTimeout((params) => {
		window.scrollTo(scrolloptions)
	}, 10);
}

const getElementOffset = (el) => {
	let top = 0;
	let left = 0;
	let element = el;

	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while (element);

	return { top, left };
}

// const bindScrollLinks = (hash, offset) => {
// 	// Bind scroll to element when clicked
// 	var els = document.querySelectorAll('.cp-scroll, a[data-scroll]');
// 	[].forEach.call(els, (el) => {
// 		let scrollElement = getElementByPageHash(el.getAttribute('href'));
// 		if (!scrollElement) { return; }

// 		el.addEventListener('click', (e) => {
// 			e.preventDefault();

// 			scrollToElement(scrollElement, offset, 'smooth');
// 		}, 10);

// 	});

// 	// // On-load Auto scroll to hash
// 	window.addEventListener('load', (e) => {
// 		scrollToElement(
// 			getElementByPageHash(windowHash),
// 			scrollOffset
// 		);
// 	});
// }

// // Initialize
// bindScrollLinks(windowHash, scrollOffset);